import { gql } from '@apollo/client'

// This query is used to fetch the summary of unfulfilled sale line items for a given sale ID.
// It retrieves the sale's picklist groups and their associated line items, including the sale
// line item ID, fulfilled quantity, and unfulfilled quantity.
export interface UnfulfilledSaleEditingSummaryLineItem {
  saleLineItemID: string | null
  fulfilledQuantity: string | null
  unfulfilledQuantity: string | null
}

export interface UnfulfilledSaleEditingQueryData {
  sale: {
    picklistGroups: Array<{
      lineItems: UnfulfilledSaleEditingSummaryLineItem[] | null
    }> | null
  } | null
}

export const UnfulfilledSaleEditingQuery = gql`
  query UnfulfilledSaleEditingQuery($id: ID!) {
    sale(id: $id) {
      picklistGroups {
        lineItems {
          saleLineItemID
          fulfilledQuantity
          unfulfilledQuantity
        }
      }
    }
  }
`
